import React, { useEffect, useState, useCallback, ChangeEvent } from "react";
import { Button, Card, MenuItem, useTheme } from "@mui/material";
import NiceModal from "@ebay/nice-modal-react";
import { useSelector } from "src/store/Store";
import { PageContainer, Breadcrumb } from "../common";
import Loading from "../common/Loading";
import { selectUserCompany } from "src/store/authSlice";
import { client } from "src/common/axiosClient";
import Modal from "../common/Modal";
import { useNavigate } from "react-router";
import MaunalTheraistByReservationList from "./MaunalTheraistByReservationList";

export default function MaunalTheraistByReservation() {
  const navigate = useNavigate();
  const theme = useTheme();

  const borderColor = theme.palette.divider;

  const [isLoding, setLoding] = useState<boolean>(false);
  const [doctorList, setDoctorList] = useState<any[]>([]);
  const [data, setData] = useState<any[]>([]);
  const [activeButton, setActiveButton] = useState("today");

  useEffect(() => {
    getDoctorList();
  }, []);

  const getDoctorList = async () => {
    setData([]);
    const response = await client.get(
      "admin/api/v1/medical-staff/MANUAL_THERAPIST"
    );
    if (response.status === 200) {
      console.log(response);
      setDoctorList([...response.data.content]);
    } else {
      console.log(response);
    }
  };

  return (
    <>
      <PageContainer>
        <Loading isLoading={isLoding} />
        <Breadcrumb
          action={
            <div className="space-x-5">
              {/* <Button
                variant="contained"
                size="small"
                onClick={() => setInsertShowModal(true)}
              >
                의사추가
              </Button> */}
            </div>
          }
        >
          <div className="flex items-center">
            <div>의료진별 예약현황</div>
            <div className="inline-flex rounded-md shadow-sm ml-5" role="group">
              <button
                type="button"
                onClick={() => setActiveButton("today")}
                className={`px-4 py-2 text-sm font-medium ${
                  activeButton === "today"
                    ? "text-blue-700 bg-gray-100"
                    : "text-gray-900 bg-white"
                } border border-gray-200 rounded-s-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 `}
              >
                오늘
              </button>
              <button
                type="button"
                onClick={() => setActiveButton("week")}
                className={`px-4 py-2 text-sm font-medium ${
                  activeButton === "list"
                    ? "text-blue-700 bg-gray-100"
                    : "text-gray-900 bg-white"
                } border border-gray-200 hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 `}
              >
                일주일
              </button>
              <button
                type="button"
                onClick={() => setActiveButton("month")}
                className={`px-4 py-2 text-sm font-medium ${
                  activeButton === "list"
                    ? "text-blue-700 bg-gray-100"
                    : "text-gray-900 bg-white"
                } border border-gray-200 rounded-e-lg hover:bg-gray-100 hover:text-blue-700 focus:z-10 focus:ring-2 focus:ring-blue-700 focus:text-blue-700 `}
              >
                이번달
              </button>
            </div>
          </div>
        </Breadcrumb>
        <Card sx={{ padding: "10px", border: `1px solid ${borderColor}` }}>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6">
            {doctorList.map((doctorItem, index) => {
              return (
                <div
                  key={index}
                  className="relative overflow-x-auto shadow-md sm:rounded-lg"
                >
                  <div className="p-4 border border-gray-300 rounded-md shadow-md">
                    <div className="relative overflow-x-auto">
                      <div className="h-48 flex items-center justify-center">
                        <img
                          src={doctorItem.profileImageUrl}
                          className="max-w-xs max-h-48 rounded-lg border"
                          alt="Apple Watch"
                        />
                      </div>
                      <MaunalTheraistByReservationList
                        id={doctorItem.id}
                        type={activeButton}
                        name={doctorItem.name}
                      />
                    </div>
                  </div>
                </div>
              );
            })}
          </div>
        </Card>
      </PageContainer>
    </>
  );
}
